import type { TeamStablefordPayload, TeamStablefordParticipant } from '@golf-app/shared';

/** Null means an older API that still expects one all-roster hole save. */
export function stablefordScorableTeamIds(data: TeamStablefordPayload): string[] | null {
  const scoreTeamIds = data.permissions.scoreTeamIds;
  if (!Array.isArray(scoreTeamIds)) return null;
  const realTeamIds = new Set(data.teams.map((team) => team.id));
  return [...new Set(scoreTeamIds.filter((teamId) => realTeamIds.has(teamId)))];
}

export function resolveStablefordScoreTeamId(
  data: TeamStablefordPayload,
  currentTeamId: string | null,
): string | null {
  const scoreTeamIds = stablefordScorableTeamIds(data);
  if (!scoreTeamIds?.length) return null;
  if (currentTeamId && scoreTeamIds.includes(currentTeamId)) return currentTeamId;
  if (data.permissions.preferredScoreTeamId
    && scoreTeamIds.includes(data.permissions.preferredScoreTeamId)) {
    return data.permissions.preferredScoreTeamId;
  }
  return scoreTeamIds[0] ?? null;
}

export function stablefordScoreEntryParticipants(
  data: TeamStablefordPayload,
  scoreTeamId: string | null,
): TeamStablefordParticipant[] {
  const scoreTeamIds = stablefordScorableTeamIds(data);
  if (scoreTeamIds === null || scoreTeamIds.length === 0 || !scoreTeamId) {
    return data.participants;
  }
  return data.participants.filter((player) => player.teamId === scoreTeamId);
}

export function firstIncompleteStablefordHole(
  data: TeamStablefordPayload,
  scoreTeamId: string | null,
): number | null {
  const participants = stablefordScoreEntryParticipants(data, scoreTeamId);
  if (participants.length === 0) return data.holes[0]?.holeNumber ?? null;
  const participantIds = new Set(participants.map((player) => player.eventPlayerId));
  for (const hole of data.holes) {
    const savedPlayerIds = new Set(
      data.holeScores
        .filter((score) => score.holeNumber === hole.holeNumber
          && participantIds.has(score.eventPlayerId))
        .map((score) => score.eventPlayerId),
    );
    if (savedPlayerIds.size < participants.length) return hole.holeNumber;
  }
  return null;
}
